module.exports = __webpack_public_path__ + "d69f51a7a33f0002c03608840e1499f1.svg";